import {required} from "vuelidate/lib/validators";  
const StrRiskBirim = {
    data() {
      return { 
        StrRiskBirimData:{  
          Riskid:"",
          Birimids:[],  
          Deleted: false 
        },
          FormDataType:{         
            Birimids:{FieldName:"Birimids",FieldTitle:this.$t('StrRiskBirim.AddEdit.Birimids'),ComboDataArray:[]},
          }   
      }
    },
    validations:{ 
      FormData: { 
        Birimids: { required }
      } 
 
  },
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }
    this.ActionsGet({"Service":"OBirim/GetTree", "Page":Page}).then((res) => {
      let tumu = [];
      tumu.push({ id: 1, label: "Tümü", children: null });
      tumu[0].children = JSON.parse(JSON.stringify(res.Data).replaceAll("[]","null"));
      this.FormDataType.Birimids.ComboDataArray = tumu;   
      });

  }
}
export default StrRiskBirim